export default "__VITE_ASSET__32b51cb4__"